module.exports = __webpack_public_path__ + "static/media/latitude.1c6743b9.png";